import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { apiurl } from "../config/config";
import confetti from "canvas-confetti";
import { MANAGER_META ,FLOOR_HEADS,FLOOR_MANAGERS} from "../json/salesTarget";




const CAMPAIGN_CONFIG = {
  startDate: "2026-03-01",
  targets: {
    GMIT: 28500, // Rahul
    ALTF: 46000, // Anand
  },
};

// const CAMPAIGN_CONFIG = {
//   startDate: "2026-02-16",
//   targets: {
//     GMIT: 13000, // Rahul
//     ALTF: 22000, // Anand
//   },
// };


const getBadge = (pos) => {
  if (pos === 0)
    return {
      text: "🥇 GOLD LEADER",
      color: "bg-yellow-400 text-black",
    };

  if (pos === 1)
    return {
      text: "🥈 SILVER",
      color: "bg-slate-300 text-black",
    };

  if (pos === 2)
    return {
      text: "🥉 BRONZE",
      color: "bg-orange-400 text-black",
    };

  return {
    text: "⭐ TOP PERFORMER",
    color: "bg-indigo-600 text-white",
  };
};






const SLIDES = [
  { type: "INTRO" },
  { type: "FLOOR" },
  { type: "MANAGER", A: "Abhishek4629", B: "SanjayRewani1619" },
  { type: "MANAGER", A: "Himanshu1203", B: "ASHWANI3434" },
];

const MANAGER_BATTLES = [
  { A: "Abhishek4629", B: "SanjayRewani1619" },
  { A: "Himanshu1203", B: "ASHWANI3434" },
];

const floorWinnerByPercentage = (aValue, aTarget, bValue, bTarget) => {
  const aPct = (aValue / aTarget) * 100;
  const bPct = (bValue / bTarget) * 100;

  if (Math.round(aPct) === Math.round(bPct)) return "DRAW";
  return aPct > bPct ? "A" : "B";
};

/* ================= UTILS ================= */

const winnerOf = (a, b) => (a === b ? "DRAW" : a > b ? "A" : "B");

const getProgressMeta = (p) => {
  if (p >= 100) return { color: "#16a34a", text: "TARGET ACHIEVED" };
  if (p >= 90) return { color: "#22c55e", text: "EXCELLENT" };
  if (p >= 80) return { color: "#4ade80", text: "VERY GOOD" };
  if (p >= 70) return { color: "#a3e635", text: "ON TRACK" };
  if (p >= 60) return { color: "#facc15", text: "NEEDS PUSH" };
  if (p >= 50) return { color: "#fbbf24", text: "NEEDS PUSH" };
  if (p >= 40) return { color: "#fb923c", text: "CRITICAL PUSH" };
  if (p >= 30) return { color: "#f97316", text: "CRITICAL PUSH" };
  if (p >= 20) return { color: "#ef4444", text: "ALERT" };
  return { color: "#dc2626", text: "HIGH ALERT" };
};

const getBattleCommentary = (A, B, aVal, bVal) => {
  if (aVal === bVal)
    return {
      headline: "It's a Perfect Draw 🤝",
      sub: "Anyone can take the lead with 1 order!",
    };
  const leaderId = aVal > bVal ? A : B;
  const trailerId = aVal > bVal ? B : A;
  const diff = Math.abs(aVal - bVal);
  return {
    headline: `${MANAGER_META[leaderId].name} is leading by +${diff} orders`,
    sub: `${MANAGER_META[trailerId].name} needs ${diff + 1} more orders to WIN 🏆`,
  };
};

/* ================= SCALE HOOK ================= */

function useTVScale() {
  const [scale, setScale] = useState(1);
  useEffect(() => {
    const updateScale = () => setScale(window.innerWidth / 1920);
    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);
  return scale;
}

// const managerWinnerByPercentage = (managers) => {
//   const enriched = managers.map((m) => {
//     const target = MANAGER_META[m.id].target;
//     const pct = target > 0 ? (m.value / target) * 100 : 0;
//     return { ...m, pct };
//   });

//   const maxPct = Math.max(...enriched.map((m) => m.pct));

//   const winners = enriched.filter(
//     (m) => Math.round(m.pct) === Math.round(maxPct)
//   );

//   // DRAW if more than one manager has same %
//   if (winners.length > 1) {
//     return enriched.map((m) => ({ ...m, status: "DRAW" }));
//   }

//   return enriched.map((m) => ({
//     ...m,
//     status:
//       Math.round(m.pct) === Math.round(maxPct) ? "WIN" : "LOSE",
//   }));
// };

const managerWinnerByPercentage = (managers) => {
  const enriched = managers.map((m) => {
    const target = MANAGER_META[m.id].target;
    const pct = target > 0 ? (m.value / target) * 100 : 0;
    return { ...m, pct };
  });

  const sorted = [...enriched].sort((a, b) => b.pct - a.pct);

  const leader = sorted[0];
  const runnerUp = sorted[1];

  // tolerance for real draw (0.5%)
  const isDraw = runnerUp && Math.abs(leader.pct - runnerUp.pct) < 0.5;

  if (isDraw) {
    return enriched.map((m) => ({ ...m, status: "DRAW" }));
  }

  return enriched.map((m) => ({
    ...m,
    status: m.id === leader.id ? "WIN" : "LOSE",
  }));
};

/* ================= MAIN COMPONENT ================= */

// export default function AdvancedScreen() {
//   const scale = useTVScale();
//   const [managerOrders, setManagerOrders] = useState({});
//   const [slide, setSlide] = useState(0);
//   const [lastWinner, setLastWinner] = useState(null);
//   const crowdAudio = useRef(null);
//   const winAudio = useRef(null);

//   /* ---------- FETCH ORDERS ---------- */
//   useEffect(() => {
//     const fetchData = async () => {
//       const res = await axios.get(`${apiurl}/utils/crm/realTimeOrderData`, {
//         headers: { token: "ad2355a9d54335e27e2c3a3ed5b6e381" },
//         params: { from_date: "2026-01-27", to_date: "2026-01-27" },
//       });
//       const list = res?.data?.data?.result?.data?.managers || [];
//       const map = {};
//       list.forEach((m) => (map[m.o_manager_name] = Number(m.totalOrders || 0)));
//       setManagerOrders(map);
//     };
//     fetchData();
//     const api = setInterval(fetchData, 30000);
//     return () => clearInterval(api);
//   }, []);

//   /* ---------- SLIDE CYCLE ---------- */
//   const current = SLIDES[slide];
//   useEffect(() => {
//     const duration =
//       current.type === "INTRO" ? 5000 :
//       current.type === "FLOOR" ? 15000 :
//       20000; // MANAGER
//     const timer = setTimeout(() => setSlide((s) => (s + 1) % SLIDES.length), duration);
//     return () => clearTimeout(timer);
//   }, [current.type]);

//   /* ---------- FLOOR DATA ---------- */
//   const floorData = useMemo(() => {
//     const sum = (arr) => arr.reduce((a, b) => a + (managerOrders[b] || 0), 0);
//     return { GMIT: sum(FLOOR_MANAGERS.GMIT), ALTF: sum(FLOOR_MANAGERS.ALTF) };
//   }, [managerOrders]);

//   /* ---------- MANAGER BATTLE ---------- */
//   const managerBattle = useMemo(() => {
//     if (current.type !== "MANAGER") return null;
//     if (current.A === current.B) return null;
//     const aVal = managerOrders[current.A] || 0;
//     const bVal = managerOrders[current.B] || 0;
//     return { aVal, bVal, win: winnerOf(aVal, bVal), diff: Math.abs(aVal - bVal) };
//   }, [current, managerOrders]);

//   /* ---------- CONFETTI + SOUND ---------- */
//   useEffect(() => {
//     if (managerBattle?.win && managerBattle.win !== "DRAW") {
//       confetti({ particleCount: 120, spread: 120 });
//       setLastWinner(managerBattle.win);
//       crowdAudio.current?.play();
//       winAudio.current?.play();
//     }
//   }, [managerBattle]);

//   /* ---------- AUDIO UNLOCK ---------- */
//   useEffect(() => {
//     const unlock = () => {
//       crowdAudio.current?.play();
//       winAudio.current?.play();
//       window.removeEventListener("click", unlock);
//       window.removeEventListener("touchstart", unlock);
//     };
//     window.addEventListener("click", unlock);
//     window.addEventListener("touchstart", unlock);
//     return () => {
//       window.removeEventListener("click", unlock);
//       window.removeEventListener("touchstart", unlock);
//     };
//   }, []);

//   return (
//     <div
//       style={{ transform: `scale(${scale})`, transformOrigin: "top left", width: 1920, height: 1080 }}
//       className="bg-gradient-to-br from-slate-50 via-white to-slate-100 overflow-hidden"
//     >
//       <audio ref={crowdAudio} src={crowdSoundFile} preload="auto" />
//       <audio ref={winAudio} src={winSoundFile} preload="auto" />

//       {current.type === "INTRO" && <IntroSlide />}
//       {current.type === "FLOOR" && <FloorSlide floorData={floorData} />}
//       {current.type === "MANAGER" && managerBattle && (
//         <ManagerBattleSlide battle={managerBattle} A={current.A} B={current.B} />
//       )}
//     </div>
//   );
// }

export default function AdvancedScreen() {

    const [campaignData, setCampaignData] = useState({});
const [managerLoginData, setManagerLoginData] = useState([]);
    
  const scale = useTVScale();
  const [managerOrders, setManagerOrders] = useState({});
  const [managersDetails, setManagersDetails] = useState([]);
  const [slideType, setSlideType] = useState("INTRO");
  const [battleIndex, setBattleIndex] = useState(0);
  const [floorIndex, setFloorIndex] = useState(0);
  const [groupIndex, setGroupIndex] = useState(0);




  const fetchManagerLoginSummary = async () => {
  try {
    const res = await axios.get(
      `${apiurl}/utils/crm/getManagerAgentSummary` // your backend route
    );

    if (res.data?.success) {
      setManagerLoginData(res.data.data.data || []);
      console.log("Manager Login Summary:", res.data.data);
    }

  } catch (err) {
    console.error("Login Summary Error:", err);
  }
};

useEffect(() => {
  fetchManagerLoginSummary(); // initial call

  const interval = setInterval(() => {
    fetchManagerLoginSummary();
  }, 60 * 10 * 1000); // every 10 minutes

  return () => clearInterval(interval);
}, []);



  const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

const [teamData, setTeamData] = useState([]);

const fetchPerformance = async () => {
  try {

    const baseParams = {
      from_date: today,
      to_date: today,
      agent_ids: "",
      manager_ids: ""
    };

    const [dcRes, ppRes] = await Promise.all([
      axios.get(`${apiurl}/utils/crm/realTimeOrderData`, {
        params: { ...baseParams, tl_ids: "Superdc" }
      }),
      axios.get(`${apiurl}/utils/crm/realTimeOrderData`, {
        params: { ...baseParams, tl_ids: "Super_Paachan_Pro" }
      })
    ]);

    const dcOrders =
      dcRes?.data?.data?.result?.data?.total?.totalOrders || 0;

    const ppOrders =
      ppRes?.data?.data?.result?.data?.total?.totalOrders || 0;

    const teams = [
      {
        team_name: "SUPER_DC_TEAM",
        orders: dcOrders,
        target: 240,
        image: "/images/superDCTeam.png"
      },
      {
        team_name: "SUPER_PP_TEAM",
        orders: ppOrders,
        target: 240,
        image: "/images/superPPTeam.png"
      }
    ];

    setTeamData(teams);

  } catch (error) {
    console.error("Team API Error:", error);
  }
};
useEffect(() => {

  fetchPerformance();

  const interval = setInterval(fetchPerformance, 50000);

  return () => clearInterval(interval);

}, []);


const managerLoginMap = useMemo(() => {
  const map = {};
  managerLoginData.forEach((m) => {
    map[m.user_name] = m;   // ✅ MUST MATCH m.id
  });
  return map;
}, [managerLoginData]);


const managerDetailsMap = useMemo(() => {
  const map = {};
  managersDetails.forEach((m) => {
    map[m.o_manager_name] = m;   // ✅ IMPORTANT
  });
  return map;
}, [managersDetails]);


  /* ---------- FETCH ORDERS ---------- */
  //   useEffect(() => {
  //     const fetchData = async () => {
  //       const res = await axios.get(`${apiurl}/utils/crm/realTimeOrderData`, {
  //         headers: { token: "ad2355a9d54335e27e2c3a3ed5b6e381" },
  //         params: { from_date: "2026-01-27", to_date: "2026-01-27" },
  //       });
  //       const list = res?.data?.data?.result?.data?.managers || [];
  //       const map = {};
  //       list.forEach((m) => (map[m.o_manager_name] = Number(m.totalOrders || 0)));
  //       setManagerOrders(map);
  //     };
  //     fetchData();
  //     const api = setInterval(fetchData, 30000);
  //     return () => clearInterval(api);
  //   }, []);

  /* ---------- FETCH ORDERS ---------- */
//   useEffect(() => {
//     const fetchData = async () => {
//       // 🔥 get today date (YYYY-MM-DD)
//       const today = new Date().toISOString().split("T")[0];

//       const res = await axios.get(`${apiurl}/utils/crm/realTimeOrderData2`, {
//         headers: { token: "ad2355a9d54335e27e2c3a3ed5b6e381" },
//         params: {
//           from_date: today,
//           to_date: today,
//         },
//       });

//       const list = res?.data?.data?.result?.data?.managers || [];
//       setManagersDetails(list);
//       const map = {};
//       list.forEach((m) => {
//         map[m.o_manager_name] = Number(m.totalOrders || 0);
//       });

//       setManagerOrders(map);







//       const campaignStart = CAMPAIGN_CONFIG.startDate;
// // const today = new Date().toISOString().split("T")[0];

// const campaignRes = await axios.get(
//   `${apiurl}/utils/crm/realTimeOrderData2`,
//   {
//     headers: { token: "ad2355a9d54335e27e2c3a3ed5b6e381" },
//     params: {
//       from_date: campaignStart,
//       to_date: today,
//     },
//   }
// );

// const campaignList =
//   campaignRes?.data?.data?.result?.data?.managers || [];

// const campaignMap = {};

// campaignList.forEach((m) => {
//   campaignMap[m.o_manager_name] = Number(
//     m.totalOrders || 0
//   );
// });

// setCampaignData(campaignMap);

//       // console.log("list",list);

//       console.log("params", {
//   from_date: campaignStart,
//   to_date: today,
// });

//     };


    
//     fetchData();

//     const api = setInterval(fetchData, 30000);
//     return () => clearInterval(api);
//   }, []);

  

  //   console.log("managersDetails",managersDetails)


  useEffect(() => {
  const fetchData = async () => {
    try {
      // ===== DATES =====
      const today = new Date().toISOString().split("T")[0];
      const campaignStart = CAMPAIGN_CONFIG.startDate;

      // ===== PARALLEL API CALLS (FAST) =====
      const [dailyRes, campaignRes] = await Promise.all([
        axios.get(`${apiurl}/utils/crm/realTimeOrderData2`, {
          headers: { token: "ad2355a9d54335e27e2c3a3ed5b6e381" },
          params: {
            from_date: today,
            to_date: today,
          },
        }),

        axios.get(`${apiurl}/utils/crm/realTimeOrderData2`, {
          headers: { token: "ad2355a9d54335e27e2c3a3ed5b6e381" },
          params: {
            from_date: campaignStart,
            to_date: today,
          },
        }),
      ]);

      /* ===== DAILY DATA ===== */
      const dailyList =
        dailyRes?.data?.data?.result?.data?.managers || [];

      setManagersDetails(dailyList);

      const dailyMap = {};
      dailyList.forEach((m) => {
        dailyMap[m.o_manager_name] = Number(
          m.totalOrders || 0
        );
      });

      setManagerOrders(dailyMap);

      /* ===== CAMPAIGN DATA ===== */
      const campaignList =
        campaignRes?.data?.data?.result?.data?.managers || [];

      const campaignMap = {};

      campaignList.forEach((m) => {
        campaignMap[m.o_manager_name] = Number(
          m.totalOrders || 0
        );
      });

      setCampaignData(campaignMap);

      console.log("Campaign params:", {
        from_date: campaignStart,
        to_date: today,
      });

    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  // first load
  fetchData();

  // auto refresh
  const api = setInterval(fetchData, 30000);

  return () => clearInterval(api);
}, []);


  /* ---------- FLOOR DATA ---------- */
  const floorData = useMemo(() => {
    const sum = (arr) => arr.reduce((a, b) => a + (managerOrders[b] || 0), 0);
    return { GMIT: sum(FLOOR_MANAGERS.GMIT), ALTF: sum(FLOOR_MANAGERS.ALTF) };
  }, [managerOrders]);

  /* ---------- MANAGER BATTLES ---------- */
  //   const MANAGER_BATTLES = [
  //     { A: "Abhishek4629", B: "SanjayRewani1619" },
  //     { A: "Himanshu1203", B: "ASHWANI3434" },
  //   ];


  const campaignFloorData = useMemo(() => {
  const sum = (arr) =>
    arr.reduce((a, b) => a + (campaignData[b] || 0), 0);

  return {
    GMIT: sum(FLOOR_MANAGERS.GMIT),
    ALTF: sum(FLOOR_MANAGERS.ALTF),
  };
}, [campaignData]);


  const MANAGER_GROUPS = [
    ["SanjayRewani1619", "JayVijay5099"],
    ["Himanshu1203", "ASHWANI3434"],
    ["Abhishek4629", "LavitBhati714"],
  ];

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (slideType === "INTRO") {
//          setSlideType("CAMPAIGN");
//       } else if (slideType === "CAMPAIGN") {
//         setSlideType("FLOOR");
//       } else if (slideType === "FLOOR") {
//         setSlideType("MANAGER");
//         setGroupIndex(0);
//       } else if (slideType === "MANAGER") {
//         if (groupIndex + 1 < MANAGER_GROUPS.length) {
//           setGroupIndex((g) => g + 1);
//         } else {
//           setGroupIndex(0);
//           setSlideType("FLOOR");
//         }
//       }
//     }, 10000);

//     return () => clearTimeout(timer);
//   }, [slideType, groupIndex]);

const duration =
  slideType === "CAMPAIGN" ? 15000 : 10000;

useEffect(() => {
  const timer = setTimeout(() => {

    // INTRO runs only once
    if (slideType === "INTRO") {
      setSlideType("FLOOR");
    }

    // FLOOR → MANAGER
    else if (slideType === "FLOOR") {
      setSlideType("MANAGER");
      setGroupIndex(0);
    }

    // MANAGER groups rotation
    else if (slideType === "MANAGER") {
      if (groupIndex + 1 < MANAGER_GROUPS.length) {
        setGroupIndex((g) => g + 1);
      } else {
        setGroupIndex(0);
        setSlideType("CAMPAIGN");
      }
    }
    else if (slideType === "CAMPAIGN") {
      setSlideType("TEAMWISE");
    }

    // CAMPAIGN → FLOOR (loop)
    else if (slideType === "TEAMWISE") {
      setSlideType("FLOOR");
    }

  }, 10000);

  return () => clearTimeout(timer);

}, [slideType, groupIndex]);


  const currentGroup =
    slideType === "MANAGER" ? MANAGER_GROUPS[groupIndex] : null;

  //   const managerGroupData = useMemo(() => {
  //     if (!currentGroup) return [];

  //     const values = currentGroup.map((id) => ({
  //       id,
  //       value: managerOrders[id] || 0,
  //     }));

  //     const max = Math.max(...values.map((v) => v.value));

  //     return values.map((v) => ({
  //       ...v,
  //       status: v.value === max && max > 0 ? "WIN" : "LOSE",
  //     }));
  //   }, [currentGroup, managerOrders]);

  const managerGroupData = useMemo(() => {
    if (!currentGroup) return [];

    const baseData = currentGroup.map((id) => ({
      id,
      value: managerOrders[id] || 0,
    }));

    return managerWinnerByPercentage(baseData);
  }, [currentGroup, managerOrders]);

  //   /* ---------- SLIDE CYCLE ---------- */
  //   useEffect(() => {
  //     let duration = 0;
  //     if (slideType === "INTRO") duration = 5000;
  //     else if (slideType === "FLOOR") duration = 15000;
  //     else duration = 20000; // MANAGER

  //     const timer = setTimeout(() => {
  //       if (slideType === "INTRO") {
  //         setSlideType("FLOOR"); // intro always shows first
  //       } else if (slideType === "FLOOR") {
  //         setSlideType("MANAGER");
  //         setBattleIndex(0); // start first battle
  //       } else if (slideType === "MANAGER") {
  //         if (battleIndex + 1 < MANAGER_BATTLES.length) {
  //           setBattleIndex((b) => b + 1); // next battle
  //         } else {
  //           setBattleIndex(0);
  //           setFloorIndex((f) => (f + 1) % FLOOR_HEADS.length);
  //           setSlideType("FLOOR");
  //         }
  //       }
  //     }, duration);

  //     return () => clearTimeout(timer);
  //   }, [slideType, battleIndex, floorIndex]);

  /* ---------- SLIDE CYCLE : STRICT 10s ---------- */
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (slideType === "INTRO") {
//         setSlideType("FLOOR");
//       } else if (slideType === "FLOOR") {
//         setSlideType("MANAGER");
//         setBattleIndex(0);
//       } else if (slideType === "MANAGER") {
//         if (battleIndex + 1 < MANAGER_BATTLES.length) {
//           setBattleIndex((b) => b + 1);
//         } else {
//           setBattleIndex(0);
//           setSlideType("FLOOR");
//         }
//       }
//     }, 10000); // 🔥 ALWAYS 10 SECONDS

//     return () => clearTimeout(timer);
//   }, [slideType, battleIndex]);

  /* ---------- CURRENT DATA ---------- */
  const currentFloor = FLOOR_HEADS[floorIndex];
  const currentBattle =
    slideType === "MANAGER" ? MANAGER_BATTLES[battleIndex] : null;

  // Compute manager battle data
  const managerBattle = useMemo(() => {
    if (!currentBattle) return null;
    const aVal = managerOrders[currentBattle.A] || 0;
    const bVal = managerOrders[currentBattle.B] || 0;
    const win = winnerOf(aVal, bVal);
    const diff = Math.abs(aVal - bVal);
    return { aVal, bVal, win, diff };
  }, [currentBattle, managerOrders]);



  const floorAgentStats = useMemo(() => {

  const calculateFloorStats = (managerIds) => {

    let totalAgents = 0;
    let loginAgents = 0;
    let below3Orders = 0;

    managerIds.forEach((id) => {

      const login = managerLoginMap[id];
      const details = managerDetailsMap[id];

      if (login) {
        totalAgents += Number(login.total_agents || 0);
        loginAgents += Number(login.today_login_count || 0);
      }

      if (details) {
        below3Orders += Number(details.agent_count_below_3 || 0);
      }

    });

    const shrinkage =
      totalAgents > 0
        ? ((totalAgents - loginAgents) / totalAgents) * 100
        : 0;

    return {
      totalAgents,
      loginAgents,
      shrinkage,
      below3Orders,
    };
  };

  return {
    GMIT: calculateFloorStats(FLOOR_MANAGERS.GMIT),
    ALTF: calculateFloorStats(FLOOR_MANAGERS.ALTF),
  };

}, [managerLoginMap, managerDetailsMap]);
  

  return (
    <div
      style={{
        transform: `scale(${scale})`,
        transformOrigin: "top left",
        width: 1920,
        height: 1080,
      }}
      className="bg-gradient-to-br from-slate-50 via-white to-slate-100 overflow-hidden"
    >
      {/* <audio ref={crowdAudio} src={crowdSoundFile} preload="auto" />
      <audio ref={winAudio} src={winSoundFile} preload="auto" /> */}

      {/* {slideType === "INTRO" &&   <CampaignSlide floorData={campaignFloorData} />} */}
      {slideType === "INTRO" && <IntroSlide />}
      {/* {slideType === "INTRO" && <TeamWiseCard data={teamData} />} */}
      {slideType === "CAMPAIGN" && (
  <CampaignSlide floorData={campaignFloorData} />
)}
      {slideType === "TEAMWISE" && (
  <TeamWiseCard data={teamData} />
)}

      {slideType === "FLOOR" && <FloorSlide floorData={floorData}  floorAgentStats={floorAgentStats} />}
      {/* {slideType === "MANAGER" && managerBattle && (
        <ManagerBattleSlide battle={managerBattle} A={currentBattle.A} B={currentBattle.B} />
      )} */}

      {slideType === "MANAGER" && (
        <ManagerGroupSlide
        //   managers={managerGroupData}
        //   managersDetails={managersDetails}
        //  managerLoginMap={managerLoginMap}
  managers={managerGroupData}
  managerDetailsMap={managerDetailsMap}
  managerLoginMap={managerLoginMap}
        />
      )}
    </div>
  );
}

/* ================= INTRO SLIDE ================= */

function IntroSlide() {
  return (
    <SlideWrapper>
      <motion.div
        className="text-center mb-16"
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <motion.h1
          animate={{ scale: [1, 1.04, 1] }}
          transition={{ repeat: Infinity, duration: 1.6 }}
          className="text-[96px] font-black tracking-tight bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent"
        >
          🚀 Today’s Sales Battle
        </motion.h1>
        <p className="mt-6 text-[40px] font-semibold text-gray-600">
          Live • Competitive • High Energy
        </p>
      </motion.div>

      <div className="grid grid-cols-2 gap-24 mt-10">
        {FLOOR_HEADS.map((f) => (
          <motion.div
            key={f.key}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-white rounded-[36px] p-12 text-center shadow-xl"
          >
            <img
              src={f.photo}
              className="w-64 h-64 mx-auto rounded-full border-4 border-indigo-500"
            />
            <h2 className="text-[52px] font-black mt-6">{f.name}</h2>
            <p className="text-[32px] text-gray-600">
              Target: <b>{f.target}</b>
            </p>
          </motion.div>
        ))}
      </div>
    </SlideWrapper>
  );
}

/* ================= FLOOR SLIDE ================= */

function FloorSlide({ floorData ,floorAgentStats}) {
  //   const win = winnerOf(floorData.GMIT, floorData.ALTF);
  const win = floorWinnerByPercentage(
    floorData.GMIT,
    FLOOR_HEADS[0].target,
    floorData.ALTF,
    FLOOR_HEADS[1].target,
  );

  return (
    <SlideWrapper>
      <h1 className="text-6xl font-black text-center mb-10">
        Live Floor Performance
      </h1>
      <div className="grid grid-cols-2 gap-12">
        {FLOOR_HEADS.map((f, i) => (
          <AdvancedFloorCard
            key={f.key}
            floor={f}
            value={i === 0 ? floorData.GMIT : floorData.ALTF}
            achievement={Math.round(
              ((i === 0 ? floorData.GMIT : floorData.ALTF) / f.target) * 100,
            )}
            isWinner={win === (i === 0 ? "A" : "B")}
            isLoser={win === (i === 0 ? "B" : "A")}
            isDraw={win === "DRAW"}
            stats={i === 0 ? floorAgentStats.GMIT : floorAgentStats.ALTF}
          />
        ))}
      </div>
    </SlideWrapper>
  );
}

/* ================= MANAGER BATTLE SLIDE ================= */

function ManagerBattleSlide({ battle, A, B }) {
  const { aVal, bVal, win } = battle;
  const commentary = getBattleCommentary(A, B, aVal, bVal);

  return (
    <SlideWrapper>
      <LiveCommentary headline={commentary.headline} sub={commentary.sub} />
      <div className="grid grid-cols-2 gap-5 mt-10">
        <ManagerCard
          id={A}
          value={aVal}
          status={win === "A" ? "WIN" : win === "B" ? "LOSE" : "DRAW"}
        />
        <ManagerCard
          id={B}
          value={bVal}
          status={win === "B" ? "WIN" : win === "A" ? "LOSE" : "DRAW"}
        />
      </div>
    </SlideWrapper>
  );
}

/* ================= SHARED COMPONENTS ================= */

const SlideWrapper = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center px-5 py-5">
    <AnimatePresence mode="wait">
      <motion.div
        key={Math.random()}
        initial={{ opacity: 0, y: 60, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -60, scale: 0.98 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="w-full rounded-[40px] p-12 bg-white shadow-[0_30px_80px_rgba(0,0,0,0.12)] border border-gray-200 text-gray-900"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  </div>
);

const ManagerCard = ({ id, value, status, managerData,loginData, position }) => {


  console.log("loginData", loginData);
  const m = MANAGER_META[id];
  const pct = Math.min(100, Math.round((value / m.target) * 100));
  const { color, text } = getProgressMeta(pct);
  const remaining = Math.max(m.target - value, 0);

  console.log("managerData", managerData);
  const badge = getBadge(position);


  const total = loginData?.total_agents || 0;
const loggedIn = loginData?.today_login_count || 0;

const loginPercentage = total
  ? ((loggedIn / total) * 100)
  : 0;

const notLoginPercentage = 100 - loginPercentage;

  return (
    <motion.div
      animate={status === "WIN" ? { scale: [1, 1.03, 1] } : {}}
      transition={{ repeat: Infinity, duration: 1.4 }}
      className="relative p-8 rounded-3xl border-4 text-center overflow-hidden"
      style={{
        borderColor: color,
        boxShadow:
          status === "WIN"
            ? "0 0 40px rgba(34,197,94,0.6)"
            : "0 0 20px rgba(0,0,0,0.15)",
      }}
    >
      <StatusStrip status={status} />
      <div
        className="mx-auto w-72 h-72 rounded-full p-2 mb-6"
        style={{
          background: `radial-gradient(circle, ${color} 0%, transparent 70%)`,
        }}
      >
        {/* ADD HERE 👇 */}
        {/* {managerData?.agent_count_below_3 !== undefined && (
          <div className="mt-4">
            <p className="text-[28px] font-black text-red-600 bg-red-50 border border-red-200 rounded-xl py-2 px-4 inline-block">
              ⚠ Agents below 3 orders: {managerData.agent_count_below_3}
            </p>
          </div>
        )} */}

        {/* {managerData?.agent_count_below_3 !== undefined && (
          <div className="mt-4">
            <p 
className={`left-1/2 -translate-x-1/2 px-5 py-2 rounded-full text-lg font-black shadow-lg ${badge.color}`}
            >
              ⚠ Agents below 3 orders: {managerData.agent_count_below_3}
            </p>
          </div>
        )} */}

{/* 
                <div
          className={`absolute top-12 left-1/2 -translate-x-1/2 px-5 py-2 rounded-full text-lg font-black shadow-lg ${badge.color}`}
        >
          {badge.text}
        </div> */}

        {/* 🔥 POSITION BADGE */}
        {/* <div
          className={`absolute top-12 left-1/2 -translate-x-1/2 px-5 py-2 rounded-full text-lg font-black shadow-lg ${badge.color}`}
        >
          {badge.text}
        </div> */}

        <img
          src={m.photo}
          className="w-full h-full rounded-full border-4 mt-3"
          style={{ borderColor: color }}
        />
      </div>
      <h2 className="text-3xl font-black">{m.name}</h2>
      <div className="text-[96px] font-extrabold leading-none">
        <span style={{ color }}>{value}</span>
        <span className="opacity-40 text-[56px]"> / {m.target}</span>
      </div>
      <p className="mt-4 text-[34px] font-semibold text-gray-700">
        {remaining > 0
          ? `${remaining} orders to target`
          : "Target completed 🎉"}
      </p>

      <div className="mt-4 flex justify-center gap-4">
        {loginData && (
          <>
                    <div
                    className="bg-gray-50 border rounded-lg p-1 text-center px-2"
                  >
                    <p className="text-xs text-gray-500 uppercase">Total Agents</p>
                    <p className="text-xl font-bold text-gray-500">{loginData.total_agents || 0}</p>
                  </div>
                    <div
                    className="bg-green-50 border border-green-900 rounded-lg p-1 px-2 text-center"
                  >
                    <p className="text-xs text-green-500 uppercase">Login Agents</p>
                    <p className="text-xl font-bold text-green-500">{loginData.today_login_count || 0}</p>
                  </div>

<div className="bg-red-50 border border-red-900 rounded-lg p-1 px-2 text-center">
  <p className="text-xs text-red-500 uppercase">Shrinkage %</p>
  <p className="text-xl font-bold text-red-600">
    {total ? notLoginPercentage.toFixed(1) : 0}%
  </p>
</div>
                  </>
)}
                    {managerData?.agent_count_below_3 !== undefined && (
                              <div
                    className="bg-red-50 border border-red-900 rounded-lg p-1 px-2 text-center"
                  >
                    <p className="text-xs text-red-500 uppercase">Agents Below 3 Orders</p>
                    <p className="text-xl font-bold text-red-900">{managerData?.agent_count_below_3 || 0}</p>
                  </div>
        )}
</div>
      <div className="h-5 bg-gray-200 rounded-full overflow-hidden mt-4">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 1 }}
          className="h-full rounded-full"
          style={{ backgroundColor: color }}
        />
      </div>
      <div className="mt-4 flex justify-between items-center">
        <p className="text-[30px] font-extrabold" style={{ color }}>
          {pct}% achieved
        </p>
        <p className="text-[30px] font-black tracking-wider" style={{ color }}>
          {text}
        </p>
      </div>
    </motion.div>
  );
};

const StatusStrip = ({ status }) => (
  <div
    className={`absolute top-0 left-0 right-0 py-2 text-white font-bold text-xl rounded-t-3xl ${status === "WIN" ? "bg-green-600" : status === "LOSE" ? "bg-red-600" : "bg-gray-600"}`}
  >
    {status === "WIN"
      ? "🏆 WINNER"
      : status === "LOSE"
        ? "😞 LOSER"
        : "🤝 DRAW"}
  </div>
);

function LiveCommentary({ headline, sub }) {
  return (
    <motion.div
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="mb-10 w-full mx-auto rounded-3xl bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 text-white shadow-[0_0_60px_rgba(99,102,241,0.8)]"
    >
      <div className="px-12 py-6 text-center">
        <motion.h2
          animate={{ scale: [1, 1.04, 1] }}
          transition={{ repeat: Infinity, duration: 1.5 }}
          className="text-5xl font-black tracking-wide"
        >
          {headline}
        </motion.h2>
        <p className="mt-3 text-3xl font-bold text-yellow-300">{sub}</p>
        <motion.span
          animate={{ opacity: [1, 0.4, 1] }}
          transition={{ repeat: Infinity, duration: 1 }}
          className="inline-block mt-4 bg-black/40 px-6 py-2 rounded-full text-xl font-bold"
        >
          🔴 LIVE BATTLE
        </motion.span>
      </div>
    </motion.div>
  );
}

function AdvancedFloorCard({ floor, value, isWinner, isLoser , stats}) {
  const target = floor.target;
  const remaining = Math.max(target - value, 0);
  const pct = Math.min(100, Math.round((value / target) * 100));
  const { color, text } = getProgressMeta(pct);
  const stripStyle = isWinner
    ? "bg-green-600"
    : isLoser
      ? "bg-red-600"
      : "bg-gray-700";
  const stripText = isWinner ? "🏆 WINNER" : isLoser ? "😞 LOSER" : "🤝 DRAW";

  return (
    <motion.div
      animate={{ scale: isWinner ? [1, 1.05, 1] : 1 }}
      transition={{ repeat: isWinner ? Infinity : 0, duration: 1.3 }}
      className="relative rounded-3xl p-10 border-4 bg-white shadow-2xl"
      style={{ borderColor: color }}
    >
      <div
        className={`absolute top-0 left-0 right-0 py-3 text-center text-white font-black text-[32px] rounded-t-3xl ${stripStyle}`}
      >
        {stripText}
      </div>
      <div className="flex flex-col items-center mt-10">
        <img
          src={floor.photo}
          className="w-72 h-72 rounded-full border-4"
          style={{ borderColor: color }}
        />
        <p className="mt-4 text-[52px] font-black tracking-wide">
          {floor.name}
        </p>
      </div>
      <div className="mt-4 text-center">
        <div className="text-[80px] font-extrabold leading-none">
          <span style={{ color }}>{value}</span>
          <span className="opacity-40 text-[56px]"> / {target}</span>
        </div>
        <p className="mt-4 text-[34px] font-semibold text-gray-700">
          {remaining > 0
            ? `${remaining} orders to target`
            : "Target completed 🎉"}
        </p>
      </div>
      <div className="mt-4 flex justify-center gap-4">

  <div className="bg-gray-50 border rounded-lg p-2 text-center px-3">
    <p className="text-xs text-gray-500 uppercase">Total Agents</p>
    <p className="text-2xl font-bold text-gray-700">{stats?.totalAgents || 0}</p>
  </div>

  <div className="bg-green-50 border border-green-900 rounded-lg p-2 px-3 text-center">
    <p className="text-xs text-green-500 uppercase">Active</p>
    <p className="text-2xl font-bold text-green-600">{stats?.loginAgents || 0}</p>
  </div>

  <div className="bg-red-50 border border-red-900 rounded-lg p-2 px-3 text-center">
    <p className="text-xs text-red-500 uppercase">Shrinkage</p>
    <p className="text-2xl font-bold text-red-600">
      {stats?.shrinkage?.toFixed(1) || 0}%
    </p>
  </div>

  <div className="bg-orange-50 border border-orange-900 rounded-lg p-2 px-3 text-center">
    <p className="text-xs text-orange-500 uppercase">Below 3 Orders</p>
    <p className="text-2xl font-bold text-orange-600">
      {stats?.below3Orders || 0}
    </p>
  </div>

</div>
      <div className="mt-6">
        <div className="h-4 bg-gray-200 rounded-full overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: `${pct}%` }}
            transition={{ duration: 0.8 }}
            className="h-full rounded-full"
            style={{ backgroundColor: color }}
          />
        </div>
        <div className="mt-4 flex justify-between items-center">
          <p className="text-[32px] font-extrabold" style={{ color }}>
            {pct}% achieved
          </p>
          <p
            className="text-[32px] font-black tracking-wider"
            style={{ color }}
          >
            {text}
          </p>
        </div>
      </div>
    </motion.div>
  );
}

function ManagerGroupSlide({ managers, managerDetailsMap, managerLoginMap}) {
  const leader = managers.find((m) => m.status === "WIN");

  //   console.log("managersDetails 1450",managersDetails);
  //   console.log("managersDetails",managers);
  //   const mangerData = managersDetails[leader.id];
  //   console.log("mangerData",mangerData);
  //   console.log("leader",leader);
  return (
    <SlideWrapper>
      {leader && (
        <LiveCommentary
          headline={`🔥 ${MANAGER_META[leader.id].name} is leading`}
          sub={`Target: ${MANAGER_META[leader.id].target} orders`}
        />
      )}

      <div className="grid grid-cols-2 gap-6 mt-10">
        {/* {managers.map((m) => (
          <ManagerCard key={m.id} id={m.id} value={m.value} status={m.status} managerData={managersDetails?.[m.id]} />
        ))} */}
        {managers.map((m, index) => {
          {/* const details = managersDetails.find(
            (x) => x.o_manager_name === m.id,
          ); */}
          const details = managerDetailsMap[m.id];
const loginData = managerLoginMap[m.id];

          return (
            <ManagerCard
              key={m.id}
              id={m.id}
              value={m.value}
              status={m.status}
              managerData={details}
              loginData={loginData}
              position={index}
            />
          );
        })}
      </div>
    </SlideWrapper>
  );
}





function CampaignSlide({ floorData }) {

  // ===== WINNER LOGIC =====
  const win = floorWinnerByPercentage(
    floorData.GMIT,
    CAMPAIGN_CONFIG.targets.GMIT,
    floorData.ALTF,
    CAMPAIGN_CONFIG.targets.ALTF
  );

  const winnerName =
    win === "A"
      ? FLOOR_HEADS[0].name
      : win === "B"
      ? FLOOR_HEADS[1].name
      : "DRAW";

  return (
    <SlideWrapper>

      {/* ===== HEADER ===== */}
      <h1 className="text-6xl font-black text-center mb-6">
        🎯 Campaign Progress
      </h1>

      {/* ===== PREDICTED WINNER ===== */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-8 text-center"
      >
        <p className="text-4xl font-black text-indigo-600">
          🔮 Predicted Winner: {winnerName}
        </p>
      </motion.div>

      {/* ===== FLOOR CARDS ===== */}
      <div className="grid grid-cols-2 gap-12">

        {FLOOR_HEADS.map((f, i) => {

          const key = i === 0 ? "GMIT" : "ALTF";
          const target = CAMPAIGN_CONFIG.targets[key];

          const value =
            i === 0 ? floorData.GMIT : floorData.ALTF;

          const remaining = Math.max(target - value, 0);

          const pct = Math.min(
            100,
            Math.round((value / target) * 100)
          );

          const isWinner = win === (i === 0 ? "A" : "B");
          const isLoser = win === (i === 0 ? "B" : "A");

          return (
            <motion.div
              key={f.key}
              animate={{
                scale: isWinner ? [1, 1.04, 1] : 1,
              }}
              transition={{
                repeat: isWinner ? Infinity : 0,
                duration: 1.6,
              }}
              className={`
                relative rounded-3xl p-10 border-4 bg-white shadow-2xl
                ${isWinner ? "border-green-500" : "border-gray-200"}
              `}
            >

              {/* ===== WIN / LOSE STRIP ===== */}
              <div
                className={`
                  absolute top-0 left-0 right-0 py-3 text-center
                  text-white font-black text-2xl rounded-t-3xl
                  ${
                    isWinner
                      ? "bg-green-600"
                      : isLoser
                      ? "bg-red-600"
                      : "bg-gray-600"
                  }
                `}
              >
                {isWinner
                  ? "🏆 LEADING"
                  : isLoser
                  ? "😞 BEHIND"
                  : "🤝 DRAW"}
              </div>

              {/* ===== IMAGE ===== */}
              <div className="flex flex-col items-center mt-12">
                <img
                  src={f.photo}
                  className="w-60 h-60 rounded-full border-4 border-indigo-500"
                />

                <p className="mt-4 text-5xl font-black">
                  {f.name}
                </p>
              </div>

              {/* ===== VALUES ===== */}
              <div className="mt-6 text-center">
                <div className="text-[80px] font-black text-indigo-600">
                  {value}
                  <span className="text-[40px] opacity-50">
                    {" "} / {target}
                  </span>
                </div>

                <p className="text-3xl font-bold text-red-600 mt-2">
                  Remaining: {remaining}
                </p>
              </div>

              {/* ===== PROGRESS ===== */}
              <div className="mt-6">
                <div className="h-6 bg-gray-200 rounded-full overflow-hidden">
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${pct}%` }}
                    transition={{ duration: 1 }}
                    className="h-full bg-green-600"
                  />
                </div>

                <p className="text-2xl font-black text-green-700 mt-3 text-center">
                  {pct}% Campaign Complete
                </p>
              </div>
            </motion.div>
          );
        })}
      </div>

      {/* ===== FOOTER ===== */}
      <p className="text-center mt-8 text-3xl font-black text-indigo-600">
        🏆 Winner will be announced on 31 March
      </p>

    </SlideWrapper>
  );
}

// function CampaignSlide({ floorData }) {

//   const startDate = new Date(CAMPAIGN_CONFIG.startDate);
//   const endDate = new Date("2026-02-28");
//   const today = new Date();

//   const totalDays =
//     Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

//   const daysPassed =
//     Math.floor((today - startDate) / (1000 * 60 * 60 * 24)) + 1;

//   const daysLeft = Math.max(totalDays - daysPassed, 0);

//   const win = floorWinnerByPercentage(
//     floorData.GMIT,
//     CAMPAIGN_CONFIG.targets.GMIT,
//     floorData.ALTF,
//     CAMPAIGN_CONFIG.targets.ALTF
//   );

//   const winnerKey = win === "A" ? "GMIT" : "ALTF";

//   const calculateProjection = (value, target) => {
//     const speed = value / Math.max(daysPassed, 1);
//     const remaining = Math.max(target - value, 0);

//     const daysNeeded =
//       speed > 0 ? Math.ceil(remaining / speed) : 999;

//     const projected = new Date(today);
//     projected.setDate(today.getDate() + daysNeeded);

//     const requiredSpeed = target / totalDays;

//     return {
//       speed: speed.toFixed(1),
//       projectedDate: projected.toDateString(),
//       accelerating: speed >= requiredSpeed,
//       remaining,
//     };
//   };

//   return (
//     <SlideWrapper>

//       {/* ===== HEADER ===== */}
//       <h1 className="text-6xl font-black text-center mb-4">
//         🚨 CAMPAIGN WAR ROOM V2
//       </h1>

//       <p className="text-center text-3xl font-black text-red-600 mb-8">
//         ⏳ {daysLeft} DAYS LEFT TO FINISH
//       </p>

//       {/* ===== MAIN GRID ===== */}
//       <div className="grid grid-cols-2 gap-10">

//         {FLOOR_HEADS.map((f, i) => {

//           const key = i === 0 ? "GMIT" : "ALTF";
//           const target = CAMPAIGN_CONFIG.targets[key];
//           const value =
//             i === 0 ? floorData.GMIT : floorData.ALTF;

//           const pct = Math.min(
//             100,
//             Math.round((value / target) * 100)
//           );

//           const data = calculateProjection(value, target);

//           const isWinner = winnerKey === key;

//           return (
//             <motion.div
//               key={f.key}
//               animate={{
//                 scale: isWinner ? [1, 1.04, 1] : 1,
//               }}
//               transition={{
//                 repeat: isWinner ? Infinity : 0,
//                 duration: 1.5,
//               }}
//               className={`
//                 relative rounded-3xl p-8 bg-white border-4 shadow-2xl
//                 ${isWinner ? "border-yellow-400" : "border-gray-200"}
//               `}
//             >

//               {/* ===== CROWN ===== */}
//               {isWinner && (
//                 <motion.div
//                   animate={{ y: [0, -6, 0] }}
//                   transition={{ repeat: Infinity, duration: 1 }}
//                   className="absolute -top-6 left-1/2 -translate-x-1/2 text-5xl"
//                 >
//                   👑
//                 </motion.div>
//               )}

//               {/* ===== IMAGE ===== */}
//               <div className="flex flex-col items-center">
//                 <img
//                   src={f.photo}
//                   className="w-52 h-52 rounded-full border-4 border-indigo-500"
//                 />
//                 <p className="text-5xl font-black mt-4">
//                   {f.name}
//                 </p>
//               </div>

//               {/* ===== VALUE ===== */}
//               <div className="text-center mt-6">
//                 <p className="text-[70px] font-black text-indigo-600">
//                   {value}
//                   <span className="text-[36px] opacity-50">
//                     {" "} / {target}
//                   </span>
//                 </p>
//               </div>

//               {/* ===== SPEED ===== */}
//               <p className="text-2xl font-bold mt-2 text-blue-700 text-center">
//                 ⚡ Speed: {data.speed} orders/day
//               </p>

//               {/* ===== PROJECTION ===== */}
//               <p className="text-2xl font-black text-purple-700 text-center mt-2">
//                 🔮 Finish: {data.projectedDate}
//               </p>

//               {/* ===== ACCELERATION ===== */}
//               <p
//                 className={`text-2xl font-black text-center mt-2 ${
//                   data.accelerating
//                     ? "text-green-600"
//                     : "text-red-600"
//                 }`}
//               >
//                 {data.accelerating
//                   ? "🚀 Accelerating"
//                   : "⚠ Needs Push"}
//               </p>

//               {/* ===== PROGRESS BAR ===== */}
//               <div className="h-6 bg-gray-200 rounded-full overflow-hidden mt-5">
//                 <motion.div
//                   initial={{ width: 0 }}
//                   animate={{ width: `${pct}%` }}
//                   transition={{ duration: 1 }}
//                   className="h-full bg-green-600"
//                 />
//               </div>

//               <p className="text-center mt-3 text-2xl font-black text-green-700">
//                 {pct}% Completed
//               </p>

//             </motion.div>
//           );
//         })}
//       </div>

//       {/* ===== FOOTER ===== */}
//       <p className="text-center mt-8 text-3xl font-black text-indigo-700">
//         🏆 Winner announced on 28 Feb
//       </p>

//     </SlideWrapper>
//   );
// }



// import confetti from "canvas-confetti";


// function TeamWiseCard({ data }) {

//   const winner =
//     data?.length > 0
//       ? data.reduce((prev, curr) =>
//           prev.orders > curr.orders ? prev : curr
//         )
//       : null;

//   /* 🎆 Confetti when target reached */
//   useEffect(() => {
//     if (winner && winner.orders >= winner.target) {
//       confetti({
//         particleCount: 200,
//         spread: 120,
//         origin: { y: 0.5 }
//       });
//     }
//   }, [winner]);

//   return (
//     <SlideWrapper>

//       <h1 className="text-7xl font-black text-center mb-16 tracking-wide">
//         ⚔️ Sales Battle Arena
//       </h1>

//       <div className="grid grid-cols-2 gap-16 items-center">

//         {data.map((team) => {

//           const pct = team.target
//             ? Math.round((team.orders / team.target) * 100)
//             : 0;

//           const isWinner = winner?.team_name === team.team_name;

//           const hotStreak = team.orders > team.target * 0.7;

//           return (
//             <motion.div
//               key={team.team_name}
//               initial={{ scale: 0.8, opacity: 0 }}
//               animate={{ scale: 1, opacity: 1 }}
//               transition={{ duration: 0.6 }}
//               className={`relative rounded-3xl p-12 shadow-2xl border text-center overflow-hidden
//               ${isWinner
//                 ? "bg-gradient-to-br from-yellow-100 to-white border-yellow-400"
//                 : "bg-white border-gray-200"}
//               `}
//             >

//               {/* Winner Crown */}
//               {isWinner && (
//                 <div className="absolute -top-6 right-6 text-6xl animate-bounce">
//                   👑
//                 </div>
//               )}

//               {/* Team Name */}
//               <h2 className="text-5xl font-black tracking-wide">
//                 {team.team_name}
//               </h2>


//             <img
//               src={team.photo}
//               className="w-64 h-64 mx-auto rounded-full border-4 border-indigo-500"
//             />

//               {/* Orders */}
//               <motion.div
//                 initial={{ scale: 0.5 }}
//                 animate={{ scale: 1 }}
//                 className="text-[120px] font-black text-indigo-600 mt-6"
//               >
//                 {team.orders}
//               </motion.div>

//               <p className="text-2xl text-gray-600">
//                 Target {team.target}
//               </p>

//               {/* Progress Bar */}
//               <div className="mt-8 h-7 bg-gray-200 rounded-full overflow-hidden shadow-inner">

//                 <motion.div
//                   initial={{ width: 0 }}
//                   animate={{ width: `${pct}%` }}
//                   transition={{ duration: 1.5 }}
//                   className={`h-full ${
//                     pct >= 100
//                       ? "bg-gradient-to-r from-green-400 to-green-600"
//                       : "bg-gradient-to-r from-indigo-400 to-indigo-600"
//                   }`}
//                 />

//               </div>

//               {/* Achievement */}
//               <div className="mt-4 text-3xl font-bold text-green-600">
//                 {pct}% Achieved
//               </div>

//               {/* Target Badge */}
//               {pct >= 100 && (
//                 <motion.div
//                   initial={{ scale: 0 }}
//                   animate={{ scale: 1 }}
//                   className="mt-4 inline-block bg-green-500 text-white px-6 py-2 rounded-full font-bold"
//                 >
//                   🎯 Target Achieved
//                 </motion.div>
//               )}

//               {/* Hot Streak */}
//               {hotStreak && pct < 100 && (
//                 <div className="mt-3 text-orange-500 font-bold text-xl animate-pulse">
//                   🔥 Hot Streak
//                 </div>
//               )}

//               {/* Sales Extra Info */}
//               {/* <div className="grid grid-cols-2 gap-4 mt-8 text-lg font-semibold">

//                 <div className="bg-gray-100 rounded-xl p-3">
//                   💰 Revenue
//                   <div className="text-xl text-indigo-600">
//                     ₹{team.amount || 0}
//                   </div>
//                 </div>

//                 <div className="bg-gray-100 rounded-xl p-3">
//                   🧑‍💼 Agents
//                   <div className="text-xl text-indigo-600">
//                     {team.agents || 0}
//                   </div>
//                 </div>

//               </div> */}

//               {/* Leader Glow */}
//               {isWinner && (
//                 <motion.div
//                   animate={{ opacity: [0.2, 0.6, 0.2] }}
//                   transition={{ repeat: Infinity, duration: 2 }}
//                   className="absolute inset-0 bg-yellow-200 blur-3xl opacity-30"
//                 />
//               )}

//             </motion.div>
//           );

//         })}

//       </div>

//       {/* VS Divider */}
//       {data.length === 2 && (
//         <div className="text-center mt-16 text-7xl font-black text-red-500 animate-pulse">
//           ⚡ VS ⚡
//         </div>
//       )}

//     </SlideWrapper>
//   );
// }



// function TeamWiseCard({ data }) {

//   const winner =
//     data?.length > 0
//       ? data.reduce((prev, curr) =>
//           prev.orders > curr.orders ? prev : curr
//         )
//       : null;

//   return (
//     <SlideWrapper>

//       <h1 className="text-7xl font-black text-center mb-16">
//         ⚔️ Sales Battle Arena
//       </h1>

//       {/* <div className="grid grid-cols-2 gap-16"> */}
//       <div className="relative grid grid-cols-2 gap-16 items-center">

//         {data.length === 2 && (
//     <div className="absolute left-1/2 -translate-x-1/2 text-[110px] font-black text-red-500 animate-pulse drop-shadow-xl z-20">
//       ⚡ VS ⚡
//     </div>
//   )}
  

//         {data.map((team) => {

//           const pct = team.target
//             ? Math.round((team.orders / team.target) * 100)
//             : 0;

//           const isWinner = winner?.team_name === team.team_name;

//           return (

//             <motion.div
//               key={team.team_name}
//               initial={{ opacity: 0, y: 80 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.7 }}
//               // className="relative rounded-[40px] overflow-hidden shadow-2xl bg-gray-100 border-4 border-gray-200"
//                           className="relative rounded-[40px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.25)]"
//             >

//               {/* WINNER GREEN GLOW */}
//               {isWinner && (
//                 <div className="absolute -inset-6 bg-white blur-[120px] opacity-40 z-0" />
//               )}

//               {/* IMAGE AREA (80%) */}
//               <div className="relative h-[600px] w-full z-10">

//                 <img
//                   src={team.image}
//                   className="w-full h-full object-cover"
//                 />

//                 {/* DARK GRADIENT */}
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

//                 {/* WINNER BADGE */}
//                 {isWinner && (
//                   <div className="absolute top-6 right-6 text-7xl animate-bounce">
//                     👑
//                   </div>
//                 )}

//                 {/* TEAM NAME */}
//                 <div className="absolute bottom-8 left-8">
//                   <h2 className="text-6xl font-black text-white drop-shadow-2xl">
//                     {team.team_name}
//                   </h2>
//                 </div>

//               </div>


//               {/* STATS AREA (20%) */}
//               <div className="bg-white/95 backdrop-blur-xl p-8">

//                 <div className="grid grid-cols-3 items-center text-center">

//                   {/* Orders */}
//                   <div>
//                     <p className="text-gray-500 text-lg">Orders</p>
//                     <p className="text-5xl font-black text-indigo-600">
//                       {team.orders}
//                     </p>
//                   </div>

//                   {/* Target */}
//                   <div>
//                     <p className="text-gray-500 text-lg">Target</p>
//                     <p className="text-5xl font-black">
//                       {team.target}
//                     </p>
//                   </div>

//                   {/* Percentage */}
//                   <div>
//                     <p className="text-gray-500 text-lg">Achieved</p>
//                     <p className="text-5xl font-black text-green-600">
//                       {pct}%
//                     </p>
//                   </div>

//                 </div>

//                 {/* PROGRESS BAR */}
//                 <div className="mt-6 h-6 bg-gray-200 rounded-full overflow-hidden">

//                   <motion.div
//                     initial={{ width: 0 }}
//                     animate={{ width: `${pct}%` }}
//                     transition={{ duration: 1.4 }}
//                     className={`h-full ${
//                       pct >= 100
//                         ? "bg-gradient-to-r from-green-400 to-green-600"
//                         : "bg-gradient-to-r from-indigo-400 to-indigo-600"
//                     }`}
//                   />

//                 </div>

//               </div>

//             </motion.div>

//           );

//         })}

//       </div>
//     </SlideWrapper>
//   );
// }


function TeamWiseCard({ data }) {

  const winner =
    data?.length > 0
      ? data.reduce((prev, curr) =>
          prev.orders > curr.orders ? prev : curr
        )
      : null;

  /* 🎆 Confetti when target achieved */
  useEffect(() => {
    if (winner && winner.orders >= winner.target) {
      confetti({
        particleCount: 300,
        spread: 120,
        origin: { y: 0.6 }
      });
    }
  }, [winner]);

  return (
    <SlideWrapper>

      {/* Arena Background Glow */}
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-900 via-purple-900 to-black opacity-20 blur-3xl"/>

      <h1 className="text-7xl font-black text-center mb-16 tracking-wide">
        ⚔️ Sales Battle Arena
      </h1>

      <div className="relative grid grid-cols-2 gap-16 items-center">

        {/* VS ORB */}
        {data.length === 2 && (
          <div className="absolute left-1/2 -translate-x-1/2 z-30">

            {/* glow */}
            <div className="absolute inset-0 rounded-full bg-red-500 blur-3xl opacity-60 animate-pulse"/>

            {/* spinning ring */}
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ repeat: Infinity, duration: 8, ease: "linear" }}
              className="absolute inset-0 rounded-full border-[6px] border-red-400"
            />

            {/* VS core */}
            <div className="relative w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-br from-red-500 to-yellow-400 text-white text-6xl font-black shadow-[0_0_80px_rgba(255,0,0,0.9)]">
              {/* VS */}
              ⚡
            </div>

          </div>
        )}

        {data.map((team) => {

          const pct = team.target
            ? Math.round((team.orders / team.target) * 100)
            : 0;

          const isWinner = winner?.team_name === team.team_name;

          return (

            <motion.div
              key={team.team_name}
              initial={{ opacity: 0, y: 80 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              whileHover={{ scale: 1.04, y: -10 }}
              className="relative rounded-[40px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.35)] border-4 border-gray-300 bg-white z-20"
            >

              {/* WINNER NEON GLOW */}
              {isWinner && (
                <div className="absolute -inset-10 bg-gray-400 blur-[140px] opacity-40 animate-pulse z-0"/>
              )}

              {/* IMAGE AREA */}
              <div className="relative h-[600px] w-full z-10">

                <img
                  src={team.image}
                  className="w-full h-full object-cover"
                />

                {/* DARK GRADIENT */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"/>

                {/* WINNER PULSE BORDER */}
                {/* {isWinner && (
                  <motion.div
                    animate={{ opacity: [0.3, 0.8, 0.3] }}
                    transition={{ repeat: Infinity, duration: 2 }}
                    className="absolute inset-0 border-[6px] border-green-400 rounded-[40px]"
                  />
                )} */}

                {/* CROWN */}
                {isWinner && (
                  <div className="absolute top-6 right-6 text-7xl animate-bounce">
                    👑
                  </div>
                )}

                {/* TARGET HIT */}
                {pct >= 100 && (
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    className="absolute top-6 left-6 bg-green-500 text-white px-6 py-3 rounded-full font-black text-xl shadow-lg"
                  >
                    🎯 TARGET HIT
                  </motion.div>
                )}

                {/* TEAM NAME */}
                <div className="absolute bottom-8 left-8">
                  <h2 className="text-6xl font-black text-white drop-shadow-2xl">
                    {team.team_name}
                  </h2>
                </div>

              </div>

              {/* STATS AREA */}
              <div className="bg-white/95 backdrop-blur-xl p-8">

                <div className="grid grid-cols-3 items-center text-center">

                  {/* Orders */}
                  <div>
                    <p className="text-gray-500 text-lg">Orders</p>
                    <p className="text-5xl font-black text-indigo-600">
                      {team.orders}
                    </p>
                  </div>

                  {/* Target */}
                  <div>
                    <p className="text-gray-500 text-lg">Target</p>
                    <p className="text-5xl font-black">
                      {team.target}
                    </p>
                  </div>

                  {/* Percentage */}
                  <div>
                    <p className="text-gray-500 text-lg">Achieved</p>
                    <p className="text-5xl font-black text-green-600">
                      {pct}%
                    </p>
                  </div>

                </div>

                {/* POWER BAR */}
                <div className="mt-6 relative h-7 bg-gray-800 rounded-full overflow-hidden">

                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${pct}%` }}
                    transition={{ duration: 1.4 }}
                    className={`h-full ${
                      pct >= 100
                        ? "bg-gradient-to-r from-green-400 via-green-500 to-green-700"
                        : "bg-gradient-to-r from-indigo-400 via-purple-500 to-indigo-700"
                    }`}
                  />

                  <div className="absolute inset-0 flex items-center justify-center text-xs text-white font-bold">
                    POWER
                  </div>

                </div>

                {/* HOT STREAK */}
                {pct > 70 && pct < 100 && (
                  <div className="mt-4 text-center text-orange-500 text-xl font-bold animate-pulse">
                    🔥 Hot Streak
                  </div>
                )}

              </div>

            </motion.div>

          );

        })}

      </div>

    </SlideWrapper>
  );
}



// function TeamWiseCard({ data }) {

//   const winner =
//     data?.length > 0
//       ? data.reduce((prev, curr) =>
//           prev.orders > curr.orders ? prev : curr
//         )
//       : null;

//   /* 🎆 Confetti when target achieved */
//   useEffect(() => {
//     if (winner && winner.orders >= winner.target) {
//       confetti({
//         particleCount: 300,
//         spread: 120,
//         origin: { y: 0.6 }
//       });
//     }
//   }, [winner]);

//   return (
//     <SlideWrapper>

//       {/* ===== BACKGROUND HUD ===== */}

//       <div className="absolute inset-0 overflow-hidden">

//         {/* moving stripes */}
//         <motion.div
//           animate={{ x: ["0%", "-50%"] }}
//           transition={{ repeat: Infinity, duration: 20, ease: "linear" }}
//           className="absolute inset-0 opacity-10 bg-[repeating-linear-gradient(45deg,#6366f1_0px,#6366f1_20px,transparent_20px,transparent_40px)]"
//         />

//         {/* arena glow */}
//         <div className="absolute inset-0 bg-gradient-to-br from-indigo-900 via-purple-900 to-black opacity-30 blur-3xl"/>
//       </div>

//       {/* TITLE */}
//       <h1 className="text-7xl font-black text-center mb-16 tracking-widest text-white drop-shadow-xl">
//         ⚔️ SALES BATTLE ARENA
//       </h1>

//       <div className="relative grid grid-cols-2 gap-20 items-center px-16">

//         {/* ===== ELECTRIC VS ===== */}

//         {data.length === 2 && (
//           <div className="absolute left-1/2 -translate-x-1/2 z-40">

//             {/* electric aura */}
//             <div className="absolute inset-0 rounded-full bg-red-500 blur-3xl opacity-60 animate-pulse"/>

//             {/* lightning ring */}
//             <motion.div
//               animate={{ rotate: 360 }}
//               transition={{ repeat: Infinity, duration: 4, ease: "linear" }}
//               className="absolute inset-0 rounded-full border-[6px] border-yellow-400"
//             />

//             {/* VS core */}
//             <div className="relative w-28 h-28 flex items-center justify-center rounded-full bg-gradient-to-br from-red-500 to-yellow-400 text-white text-5xl font-black shadow-[0_0_80px_rgba(255,0,0,0.9)]">
//               ⚡
//             </div>

//           </div>
//         )}

//         {data.map((team) => {

//           const pct = team.target
//             ? Math.round((team.orders / team.target) * 100)
//             : 0;

//           const isWinner = winner?.team_name === team.team_name;

//           return (

//             <motion.div
//               key={team.team_name}
//               initial={{ opacity: 0, y: 80 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.7 }}
//               whileHover={{ scale: 1.04, y: -10 }}
//               className="relative rounded-[40px] overflow-hidden shadow-[0_30px_90px_rgba(0,0,0,0.5)] border-4 border-gray-300 bg-white z-30"
//             >

//               {/* ===== WINNER SPOTLIGHT ===== */}

//               {isWinner && (
//                 <motion.div
//                   animate={{ opacity: [0.2, 0.7, 0.2] }}
//                   transition={{ repeat: Infinity, duration: 3 }}
//                   className="absolute inset-0 bg-yellow-300 blur-[150px] z-0"
//                 />
//               )}

//               {/* ===== IMAGE ===== */}

//               <div className="relative h-[600px]">

//                 <img
//                   src={team.image}
//                   className="w-full h-full object-cover"
//                 />

//                 <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"/>

//                 {/* crown */}
//                 {isWinner && (
//                   <div className="absolute top-6 right-6 text-7xl animate-bounce">
//                     👑
//                   </div>
//                 )}

//                 {/* target hit */}
//                 {pct >= 100 && (
//                   <motion.div
//                     initial={{ scale: 0 }}
//                     animate={{ scale: 1 }}
//                     className="absolute top-6 left-6 bg-green-500 text-white px-6 py-3 rounded-full font-black text-xl shadow-lg"
//                   >
//                     🎯 TARGET HIT
//                   </motion.div>
//                 )}

//                 {/* team name */}
//                 <div className="absolute bottom-8 left-8">
//                   <h2 className="text-6xl font-black text-white drop-shadow-2xl">
//                     {team.team_name}
//                   </h2>
//                 </div>

//               </div>

//               {/* ===== HUD STATS PANEL ===== */}

//               <div className="bg-black text-white p-8 border-t-4 border-indigo-500">

//                 <div className="grid grid-cols-3 text-center">

//                   <div>
//                     <p className="text-gray-400">Orders</p>
//                     <p className="text-5xl font-black text-indigo-400">
//                       {team.orders}
//                     </p>
//                   </div>

//                   <div>
//                     <p className="text-gray-400">Target</p>
//                     <p className="text-5xl font-black">
//                       {team.target}
//                     </p>
//                   </div>

//                   <div>
//                     <p className="text-gray-400">Achieved</p>
//                     <p className="text-5xl font-black text-green-400">
//                       {pct}%
//                     </p>
//                   </div>

//                 </div>

//                 {/* POWER BAR */}

//                 <div className="mt-6 relative h-7 bg-gray-700 rounded-full overflow-hidden">

//                   <motion.div
//                     initial={{ width: 0 }}
//                     animate={{ width: `${pct}%` }}
//                     transition={{ duration: 1.5 }}
//                     className={`h-full ${
//                       pct >= 100
//                         ? "bg-gradient-to-r from-green-400 via-green-500 to-green-700"
//                         : "bg-gradient-to-r from-indigo-400 via-purple-500 to-indigo-700"
//                     }`}
//                   />

//                 </div>

//                 {/* HOT STREAK FIRE */}

//                 {pct > 70 && pct < 100 && (
//                   <div className="relative mt-4 text-center text-orange-400 font-bold text-xl">

//                     🔥 Hot Streak

//                     {/* fire particles */}
//                     <motion.div
//                       animate={{ y: [-10, -40], opacity: [1, 0] }}
//                       transition={{ repeat: Infinity, duration: 1.2 }}
//                       className="absolute left-1/2 -translate-x-1/2 text-2xl"
//                     >
//                       🔥🔥🔥
//                     </motion.div>

//                   </div>
//                 )}

//               </div>

//             </motion.div>

//           );

//         })}

//       </div>

//     </SlideWrapper>
//   );
// }




// function TeamWiseCard({ data }) {

//   const winner =
//     data?.length > 0
//       ? data.reduce((prev, curr) =>
//           prev.orders > curr.orders ? prev : curr
//         )
//       : null;

//   /* 🎆 Confetti when target achieved */
//   useEffect(() => {
//     if (winner && winner.orders >= winner.target) {
//       confetti({
//         particleCount: 400,
//         spread: 160,
//         origin: { y: 0.6 }
//       });
//     }
//   }, [winner]);

//   return (
//     <SlideWrapper className="relative overflow-hidden">

//       {/* ===== BACKGROUND HUD ===== */}
//       <div className="absolute inset-0 overflow-hidden z-0">

//         {/* moving stripes */}
//         <motion.div
//           animate={{ x: ["0%", "-50%"] }}
//           transition={{ repeat: Infinity, duration: 25, ease: "linear" }}
//           className="absolute inset-0 opacity-10 bg-[repeating-linear-gradient(45deg,#6366f1_0px,#6366f1_20px,transparent_20px,transparent_40px)]"
//         />

//         {/* arena glow */}
//         <div className="absolute inset-0 bg-gradient-to-br from-indigo-900 via-purple-900 to-black opacity-40 blur-3xl"/>
//       </div>

//       {/* TITLE */}
//       <h1 className="text-7xl lg:text-8xl font-black text-center mb-16 tracking-widest text-white drop-shadow-xl">
//         ⚔️ SALES BATTLE ARENA
//       </h1>

//       <div className="relative grid grid-cols-2 gap-24 items-center px-16">

//         {/* ===== ELECTRIC VS ===== */}
//         {data.length === 2 && (
//           <div className="absolute left-1/2 -translate-x-1/2 z-40">

//             {/* electric aura */}
//             <motion.div
//               animate={{ scale: [1, 1.2, 1], rotate: [0, 360, 0] }}
//               transition={{ repeat: Infinity, duration: 6, ease: "linear" }}
//               className="absolute inset-0 rounded-full bg-red-500 blur-3xl opacity-50"
//             />

//             {/* lightning arcs */}
//             <motion.div
//               animate={{ rotate: [0, 360] }}
//               transition={{ repeat: Infinity, duration: 3, ease: "linear" }}
//               className="absolute inset-0 rounded-full border-[6px] border-yellow-400"
//             />

//             {/* VS core */}
//             <div className="relative w-32 h-32 flex items-center justify-center rounded-full bg-gradient-to-br from-red-500 to-yellow-400 text-white text-6xl font-black shadow-[0_0_120px_rgba(255,0,0,0.9)]">
//               ⚡
//             </div>

//           </div>
//         )}

//         {data.map((team) => {

//           const pct = team.target
//             ? Math.round((team.orders / team.target) * 100)
//             : 0;

//           const isWinner = winner?.team_name === team.team_name;

//           return (
//             <motion.div
//               key={team.team_name}
//               initial={{ opacity: 0, y: 100 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               whileHover={{ scale: 1.05, y: -10 }}
//               className="relative rounded-[40px] overflow-hidden shadow-[0_40px_120px_rgba(0,0,0,0.6)] border-4 border-gray-300 bg-white z-30"
//             >

//               {/* ===== WINNER SPOTLIGHT ===== */}
//               {isWinner && (
//                 <motion.div
//                   animate={{ opacity: [0.2, 0.7, 0.2], x: [0, 30, 0] }}
//                   transition={{ repeat: Infinity, duration: 3 }}
//                   className="absolute inset-0 bg-yellow-300 blur-[180px] z-0"
//                 />
//               )}

//               {/* ===== IMAGE ===== */}
//               <div className="relative h-[600px]">

//                 <img
//                   src={team.image}
//                   className="w-full h-full object-cover"
//                 />

//                 <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"/>

//                 {/* crown */}
//                 {isWinner && (
//                   <div className="absolute top-6 right-6 text-8xl animate-bounce">
//                     👑
//                   </div>
//                 )}

//                 {/* target hit */}
//                 {pct >= 100 && (
//                   <motion.div
//                     initial={{ scale: 0 }}
//                     animate={{ scale: 1 }}
//                     className="absolute top-6 left-6 bg-green-500 text-white px-6 py-3 rounded-full font-black text-xl shadow-lg"
//                   >
//                     🎯 TARGET HIT
//                   </motion.div>
//                 )}

//                 {/* team name */}
//                 <div className="absolute bottom-8 left-8">
//                   <h2 className="text-6xl lg:text-7xl font-black text-white drop-shadow-2xl tracking-wider">
//                     {team.team_name}
//                   </h2>
//                 </div>

//               </div>

//               {/* ===== HUD STATS PANEL ===== */}
//               <div className="bg-black/90 text-white p-8 border-t-4 border-indigo-500">

//                 <div className="grid grid-cols-3 text-center">

//                   <div>
//                     <p className="text-gray-400 uppercase tracking-wider">Orders</p>
//                     <p className="text-5xl lg:text-6xl font-black text-indigo-400">{team.orders}</p>
//                   </div>

//                   <div>
//                     <p className="text-gray-400 uppercase tracking-wider">Target</p>
//                     <p className="text-5xl lg:text-6xl font-black">{team.target}</p>
//                   </div>

//                   <div>
//                     <p className="text-gray-400 uppercase tracking-wider">Achieved</p>
//                     <p className="text-5xl lg:text-6xl font-black text-green-400">{pct}%</p>
//                   </div>

//                 </div>

//                 {/* POWER BAR */}
//                 <div className="mt-6 relative h-8 bg-gray-800 rounded-full overflow-hidden shadow-inner">
//                   <motion.div
//                     initial={{ width: 0 }}
//                     animate={{ width: `${pct}%` }}
//                     transition={{ duration: 1.5 }}
//                     className={`h-full ${
//                       pct >= 100
//                         ? "bg-gradient-to-r from-green-400 via-green-500 to-green-700"
//                         : "bg-gradient-to-r from-indigo-400 via-purple-500 to-indigo-700"
//                     }`}
//                   />
//                   <div className="absolute inset-0 flex items-center justify-center text-xs lg:text-sm font-bold text-white tracking-wider">
//                     POWER
//                   </div>
//                 </div>

//                 {/* HOT STREAK FIRE */}
//                 {pct > 70 && pct < 100 && (
//                   <div className="relative mt-4 text-center text-orange-400 font-bold text-xl lg:text-2xl">

//                     🔥 Hot Streak

//                     {/* animated fire */}
//                     <motion.div
//                       animate={{ y: [-10, -50], opacity: [1, 0] }}
//                       transition={{ repeat: Infinity, duration: 1.2 }}
//                       className="absolute left-1/2 -translate-x-1/2 text-2xl lg:text-3xl"
//                     >
//                       🔥🔥🔥
//                     </motion.div>

//                   </div>
//                 )}

//               </div>

//             </motion.div>
//           );
//         })}

//       </div>

//     </SlideWrapper>
//   );
// }
